module.exports = __webpack_public_path__ + "img/default_user.0178b016.jpg";